import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { UserService } from 'src/app/services/user/user.service';
import { DataSharingService } from 'src/app/auth/data-sharing.service';
import { VendordashboardService } from 'src/app/services/dashboard/vendor/vendordashboard.service';
import { Vendordata } from 'src/app/model/vendordata.model';
import { isNullOrUndefined } from 'util';
import { isNull } from '@angular/compiler/src/output/output_ast';
import { Observable } from 'rxjs'
import { BehaviorSubject } from 'rxjs';
import { EnlistmentService } from 'src/app/services/enlistment/enlistment.service';
import { Prevendor } from 'src/app/model/prevendor.model';
import { NgForm, FormsModule } from '@angular/forms';
import { ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpErrorResponse } from '@angular/common/http';
import { distinctUntilChanged } from 'rxjs/operators';
import { Binary } from '@angular/compiler';
import { ReplaySubject } from 'rxjs';
import { Ssgcontractor } from 'src/app/model/ssgcontractor.model';
import { EvaluationService } from 'src/app/services/evaluation/evaluation.service';

@Component({
  selector: 'app-evalssgcontractor',
  templateUrl: './evalssgcontractor.component.html',
  styleUrls: ['./evalssgcontractor.component.css']
})
export class EvalssgcontractorComponent implements OnInit {

  currentUserData: any;
  vendorData: any;
  vModelData: Vendordata;

  ssgContractor: Ssgcontractor;

  stepno: string;
  applicationref: string;
  returnData: any;

  constructor(private router: Router, private userService: UserService,
    private dataSharingService: DataSharingService, private vendorDashboardService: VendordashboardService,
    private enlistmentServices: EnlistmentService, private route: ActivatedRoute,
    private evaluationService : EvaluationService) {
    this.vModelData = new Vendordata();
    this.ssgContractor = new Ssgcontractor();
    this.stepno = this.route.snapshot.params.stepno;
    this.applicationref = this.route.snapshot.params.applicationrefno;
  }

  ngOnInit() {
    this.userService.currentUser.subscribe(
      (userdata) => {
        this.currentUserData = userdata;
        if (this.currentUserData != null) {
          var currentUserId = this.currentUserData.id;

          this.evaluationService.getVendorData(this.applicationref).subscribe(
            (data) => {
              this.vendorData = data;
              this.vModelData = this.vendorData;

              var enlistData = {
                stepNo: this.stepno,
                applicationNumber: this.vModelData.applicationNumber
              }

              this.enlistmentServices.getEnlistmentFormsSsgSmg(enlistData).subscribe(
                (data) => {
                  this.returnData = data;
                  if (this.returnData.type == "ssgcontractorform") {
                    this.ssgContractor = this.returnData.ssgsmg;
                  }
                  //console.log(data);
                }
              )

            }
          )
        }
      }
    );
  }

  SubmitEnlistmentForm(form : NgForm)
  {
    
  }

}
